import {Dispatch, GetState} from '../app-types';
import {postJsonWithBody} from './fetcher';
import {showError} from '../message-box/message-box-actions';
import {fetchDocumentDetails} from '../search/duck/search-actions';
import {ProdDocument, TagUpdate} from '../search/search-types';
import {SearchPageType} from '../search/search-config';

export const upsertTag = (
    searchPageType: SearchPageType,
    doc: ProdDocument,
    updatedTagValue: TagUpdate | null
): ((dispatch: Dispatch, getState: GetState) => void) => {
    return updateTag(searchPageType, doc, updatedTagValue, '/upsertTags');
};

export const deleteTag = (
    searchPageType: SearchPageType,
    doc: ProdDocument,
    updatedTagValue: TagUpdate | null
): ((dispatch: Dispatch, getState: GetState) => void) => {
    return updateTag(searchPageType, doc, updatedTagValue, '/deleteTags');
};

export const updateTag = (
    searchPageType: SearchPageType,
    doc: ProdDocument,
    updatedTagValue: TagUpdate | null,
    endpoint: string
): ((dispatch: Dispatch, getState: GetState) => void) => {
    return (dispatch: Dispatch, getState: GetState): void => {
        const request = {
            containerName: getState().settings.containerName,
            documentId: doc.id,
            updatedTagValue: updatedTagValue,
        };
        postJsonWithBody<any>(endpoint, JSON.stringify(request))
            .then(() => {
                dispatch(fetchDocumentDetails(doc));
            })
            .catch((error) => {
                console.error('Document could not be updated. Error: ', error);
                return dispatch(showError(searchPageType, 'Document could not be updated!'));
            });
    };
};

